// import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from '../mainComponents/Layout';
import Home from '../pages/home/Home';
import AgeGate from '../pages/onBoard/Age';
import PlatformSelection from '../pages/onBoard/PlatformSelection';
import NotFound from '../pages/404/404page';
import ChooseUserName from '../pages/onBoard/chooseUsername';
import ProfilePicture from '../pages/onBoard/ProfilePicture';
import PlayScreen from '../pages/PlayAndInbox/PlayScreen';
import NglMessageView from '../pages/messageview/NglMessageView';
import Settings from '../pages/Settings/Settings';
import NotificationSettings from '../pages/Settings/Components/NotificationSettings';
import TeamNglMessages from '../pages/Settings/Components/TeamNglMessages';
import HiddenWords from '../pages/Settings/Components/HiddenWords';
import BlockedUsers from '../pages/Settings/Components/BlockedUsers';
import PauseLink from '../pages/Settings/Components/PauseLink';
import Filtering from '../pages/Settings/Components/Filtering';
import HelpScreen from '../pages/Settings/Components/HelpScreen';
import SafetyScreen from '../pages/Settings/Components/SafetyScreen';
import TermsOfUse from '../pages/Settings/Components/TermsOfUse';
import UpdateProfilePicture from '../pages/Settings/Components/UpdateprofilePicture';


const AppRoutes = () => (
  <Routes>
    {/* PUBLIC ROUTES */}
    <Route path="/" element={<Layout />}>
      <Route index element={<Navigate to="/play" replace />} />
      {/* <Route path="home/:receiverId" element={<Home receiverId={0} />} /> */}
      <Route path="/:id" element={<Home />} />
      <Route path="age" element={<AgeGate />} />
      <Route path="platform" element={<PlatformSelection />} />
      <Route path="chooseuser" element={<ChooseUserName />} />
      <Route path="profilepicture" element={<ProfilePicture />} />
      <Route path="play" element={<PlayScreen />} />
      <Route path="messageview/:id" element={<NglMessageView />} />

      {/* <Route path="messageview" element={<NglMessageView />} /> */}
      <Route path='settings' element={<Settings />} />
      <Route path="/settings/notifications" element={<NotificationSettings />} />
      <Route path="/settings/team-message" element={<TeamNglMessages />} />
      <Route path="/settings/hidden-words" element={<HiddenWords />} />
      <Route path="/settings/blocked-users" element={<BlockedUsers />} />
      <Route path="/settings/pause-link" element={<PauseLink />} />
      <Route path="/settings/filtering" element={<Filtering />} />
      <Route path="/settings/help" element={<HelpScreen />} />
      <Route path="/settings/safety-resources" element={<SafetyScreen />} />
      <Route path="/settings/terms" element={<TermsOfUse />} />
      <Route path="/settings/updatepicture" element={<UpdateProfilePicture />} />
    </Route>

    {/* PROTECTED ROUTES UNDER /app */}

    {/* 404 PAGE */}
    <Route path="*" element={<NotFound />} />
  </Routes>
);

export default AppRoutes;
